import React from "react";

import styled from "styled-components";

import { contractTypeMap } from "../../helpers/vacancyHelpers";
import VacancyImage from "../SearchResults/VacancyImage";

const StyledTable = styled.table`
  font-size: 1.25rem;
`;

function DescriptiveVacancyHead(props) {
  const { vacancy, thumbnailUrl } = props;

  const tableObject = [
    {
      fieldName: "Location:",
      value: vacancy?.location?.city,
    },
    {
      fieldName: "Rate:",
      value: vacancy?.remuneration?.description,
    },
    {
      fieldName: "Start:",
      value: vacancy?.startDate,
    },
    {
      fieldName: "Type:",
      value: contractTypeMap[vacancy?.contractType],
    },
  ];

  return (
    <div className="d-flex flex-grow-1">
      <VacancyImage imageUrl={thumbnailUrl} />

      <div className="me-auto pe-3">
        <StyledTable>
          <tbody>
            {tableObject.map((row) => {
              if (!row.value) {
                return null;
              }
              return (
                <tr key={row.fieldName}>
                  <td className="text-uppercase me-3 d-block">
                    {row.fieldName}
                  </td>
                  <td className="fw-bolder">{row.value}</td>
                </tr>
              );
            })}
          </tbody>
        </StyledTable>
      </div>
    </div>
  );
}

export default DescriptiveVacancyHead;
